import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const InnerContainer = styled(Box)(({ theme }) => ({
  padding: '1.5rem',

  [theme.breakpoints.up('lg')]: {
    padding: '1.5rem 10rem',
  },
}));

export const ContentStack = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
});

export const ContainerHeader = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  textAlign: 'center',
});

export const SectionTitle = styled(Typography)({
  fontFamily: '"Rookery new", sans-serif',
  fontSize: '1.25rem',
  fontWeight: 700,
  lineHeight: '1.625rem',
  color: '#161c27',
});

export const SectionSubtitle = styled(Typography)({
  fontFamily: '"Rookery new", sans-serif',
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: '1.25rem',
  letterSpacing: '0.0156rem',
  color: '#161c27',
});

export const CardsGrid = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
  justifyContent: 'center',
});

export const SectionWrapper = styled('section')({
  backgroundColor: '#f8f6f4',
  width: '100%',
});
